import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  background: {
    backgroundColor: "$background",
  },
  card: {
    backgroundColor: "$survey_card",
  },
  headerContainer: {
    flex: 0.15,
    flexDirection: "row",
    justifyContent: "center",
  },
  footerContainer: {
    flex: 0.15,
  },
  logo: {
    alignSelf: "flex-end",
    width: "$width_logo",
    height: "$height_logo",
  },
});
